module.exports = "/dog-racing/img/fast-betting-btn-purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/fast-betting-btn-purple.png
// module id = 1954
// module chunks = 7